import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import SocialPack from "fantastic/components/common/controls/social/SocialPack";

const SocialForm = (props) => {
  const { socials, onChange } = props
  const [showSocialServices, displayServices] = useState(false)
  const socialPackProps = { ...props, displayServices }

  const toggleSocialServices = () => {
    displayServices(!showSocialServices)
  }

  const closeSocialServices = (e) => {
    if (e.target.id === "fa-plus-toggle") return null
    if (showSocialServices) return toggleSocialServices()
  };

  const updateSocialUrl = (e, currentSocial) => {
    const updatedSocials = socials.map((social) => {
      if (social.srv === currentSocial.srv) {
        return { srv: currentSocial.srv, url: e.target.value }
      } else {
        return { ...social }
      }
    })

    onChange('socials', updatedSocials)
  }

  const removeFromSocials = (currentSocial) => {
    const updatedSocials = socials.map((social) => {
      if (social.srv === currentSocial.srv) {
        return null
      } else {
        return { ...social }
      }
    }).filter((obj) => obj)

    onChange('socials', updatedSocials)
  }

  return (
    <div className="social-form">
      { socials.map((social, index) => {
          return(
            <div className="form-group fields" key={`social-id-${index}`} >
              <img src={`/social/${social.srv}_32.png`} />
              <input
                className="form-control fantastic-form-control"
                placeholder="http://..."
                value={social.url}
                onChange={(e) => updateSocialUrl(e, social)}/>
              <a
                className="btn btn-link"
                onClick={() => removeFromSocials(social)}>
                <i className="fa fa-remove" />
              </a>
            </div>
          )
        })
      }

      <OutsideClickHandler onOutsideClick={closeSocialServices}>
          { showSocialServices && <SocialPack {...socialPackProps} /> }
      </OutsideClickHandler>

      <div className="form-group adds">
        <div className="dropup">
          <button
            className="btn btn-success"
            id="fa-plus-toggle"
            onClick={toggleSocialServices}>
            <i className="fa fa-plus" id="fa-plus-toggle"></i>
          </button>
        </div>
      </div>
    </div>
  )
};

export default SocialForm;
